import { useEffect, useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { DOCUMENT_MODE } from "../redux/constants/metaData";
import ReusableDialog from "./popupModals/ReusableDialog";
import DocumentDetailsContent from "./moreDetails/DocumentDetailsContent";
import { useDocumentDetails } from "../redux/hooks/useDocumentDetails";
import { useTheme } from "../theme/OAS365Theme";
import { WorkingDocumentDetailsDialogTitle } from "../pages/document-tabs/components/working-documents/dialogs/WorkingDocumentDetailsDialogTitle";
import { WorkingDocumentDetailsDialogActions } from "../pages/document-tabs/components/working-documents/dialogs/WorkingDocumentDetailsDialogActions";
import { WorkingDocumentDetailsDialogProgress } from "../pages/document-tabs/components/working-documents/dialogs/WorkingDocumentDetailsDialogProgress";
import { getDocIcon } from "../pages/document-tabs/components/working-documents/WorkingDocumentCard";

function DocumentDetailsPlaceholderBody({ contentText, isLoading, isNoData, isError, theme }) {
  return (
    <DialogContent
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "56px",
        textAlign: "center",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 400,
          fontFamily: "Poppins, sans-serif",
          marginBottom: "4px",
          color: theme.colors.fontColor,
        }}
      >
        {contentText}
      </Typography>
      <WorkingDocumentDetailsDialogProgress
        isDetailsNoData={isNoData}
        isDetailsError={isError}
        isDetailsLoading={isLoading}
        theme={theme}
      />
    </DialogContent>
  );
}

const MoreDetails = () => {
  const { state, closeDetails } = useDocumentDetails();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  let documentMode;

  useEffect(() => {
    setOpen(state.isOpen);
  }, [state.isOpen]);

  const handleClose = () => {
    closeDetails();
  };

  if (state.data && Object.keys(state.data).length !== 0) {
    const selectedRow = state.data;
    documentMode = selectedRow.documentMode || DOCUMENT_MODE.ifs;
  }

  if (!open) return null;

  const isDetailsComplete = state.showDetailsContent === true;

  const renderContent = () => {
    if (state.showSpinner) {
      return (
        <DocumentDetailsPlaceholderBody
          contentText=""
          isLoading
          isNoData={false}
          isError={false}
          theme={theme}
        />
      );
    }
    if (state.showDetailsContent) {
      return (
        <DocumentDetailsContent
          workingIfsDocument={state.data}
          documentMode={documentMode}
        />
      );
    }
    if (state.emptyStateType === "noData") {
      return (
        <DocumentDetailsPlaceholderBody
          contentText={state.dialogTitle}
          isLoading={false}
          isNoData
          isError={false}
          theme={theme}
        />
      );
    }
    return (
      <DocumentDetailsPlaceholderBody
        contentText={state.dialogTitle}
        isLoading={false}
        isNoData={false}
        isError
        theme={theme}
      />
    );
  };

  return (
    <ReusableDialog
      isOpen={open}
      onClose={handleClose}
      showHeader={false}
      variant="info"
      centerContent={false}
      dialogMinHeight={isDetailsComplete ? 320 : 140}
      dialogMinWidth={isDetailsComplete ? 380 : 320}
      dialogMaxWidth={isDetailsComplete ? "min(92vw, 520px)" : "min(90vw, 420px)"}
      bodyMinHeight={isDetailsComplete ? 140 : 30}
      dialogMaxHeight="95vh"
      bodyMaxHeight={isDetailsComplete ? "65vh" : undefined}
      titleContent={
        <WorkingDocumentDetailsDialogTitle
          isDetailsComplete={isDetailsComplete}
          theme={theme}
          workingIfsDocument={state.data}
          getDocIcon={getDocIcon}
        />
      }
      actions={
        <WorkingDocumentDetailsDialogActions
          isDetailsComplete={isDetailsComplete}
          isCheckinMode={false}
          theme={theme}
          onClose={handleClose}
          workingIfsDocument={state.data}
          getCheckinButtonText={() => ""}
        />
      }
    >
      {renderContent()}
    </ReusableDialog>
  );
};

export default MoreDetails;
